const routeTransitionDurationMs = 175;
const modal = "_ibqm1t8nc8n";
const route = "_ibqr1box623";
const routeWrapper = "_ibqrg378xy";

export { modal, route, routeTransitionDurationMs, routeWrapper };
import "./modal.style.linaria.module.css";
//# sourceMappingURL=modal.style.js.map
